import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DashboardPopup from '../DashboardPopup'
import Button from 'components/UI/Button/Button'
import {
  Title,
  Note,
  EmailCopy,
  ButtonRow
} from './ParentEmailPopup.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class ParentEmailPopup extends Component {
  static propTypes = {
    emails: PropTypes.arrayOf(PropTypes.string)
  }

  render () {
    return (
      <DashboardPopup
        onCancel={() => {
          this.props.setSeenStatus()
          this.props.onCancel()
        }}
        height='600px'
        width='550px'
        isSettings
      >
        <Title>
          Adding a parent email
        </Title>
        <Note>
          Adding or a parent e-mail to any of your students will send the following information to the parent:
        </Note>
        <EmailCopy>
          Hello!
          <br /><br />
          Your child's teacher would love you to see the amazing work they've been doing on Night Zookeeper.
          <br /><br />
          Here's their profile page: https://www.nightzookeeper.com/edu/zoo/profile/child-username
          <br /><br />
          You can check in on their progress regularly at the link above.
          <br /><br />
          If you would like to leave them comments, you need to sign-up for a Commenter account.
          <br /><br />
          Very best wishes,
          <br />
          The Night Zookeeper Team
          <br /><br />
          * Night Zookeeper is a writing improvement tool. We don't collect any personal information from children. If you have any questions at all about our website please contact us on support@nightzookeeper.com. We will aim to reply within 24 hours. You can review our Terms of Use and Privacy Policy at any time.
        </EmailCopy>
        <ButtonRow>
          <Button
            bgColor={colors.lightBlue}
            color='white'
            size='regular'
            width='105px'
            height='30px'
            onClick={() => {
              this.props.setSeenStatus()
              this.props.onCancel()
            }}
          >
            OK
          </Button>
        </ButtonRow>
      </DashboardPopup>
    )
  }
}
